<div class="header">
    <div class="title">Selected Imaging Studies</div>
    @if (editable) {
    <div class="header-actions">
        <button mat-stroked-button (click)="addMore()">
            <mat-icon>add</mat-icon>
            Add imaging
        </button>
        <button mat-stroked-button (click)="deleteSelected()" [disabled]="selection.selected.length === 0">
            <mat-icon>delete</mat-icon>
            Remove selected
        </button>
    </div>
    }
</div>

<div class="table">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">

        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="toggleAllRows()" [checked]="isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="selection.toggle(row)"
                    [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                </mat-checkbox>
            </td>
        </ng-container>

        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let img">
                <div class="primary">{{ imagingTitle(img) }}</div>
                <div class="secondary">ID: {{ img.id ?? '—' }}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let img">{{ img.status ?? '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="modality">
            <th mat-header-cell *matHeaderCellDef>Modality</th>
            <td mat-cell *matCellDef="let img">{{ imagingModality(img) }}</td>
        </ng-container>

        <ng-container matColumnDef="started">
            <th mat-header-cell *matHeaderCellDef>Started</th>
            <td mat-cell *matCellDef="let img">{{ imagingStarted(img) }}</td>
        </ng-container>

        @if (editable) {
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let img" class="actions">
                <button mat-icon-button (click)="deleteRow(img)" aria-label="Remove">
                    <mat-icon>close</mat-icon>
                </button>
            </td>
        </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
    </table>

    @if (dataSource.data.length === 0) {
    <div class="muted" style="padding: 12px 0;">No ImagingStudy selected yet.</div>
    }
</div>